import { gql } from 'apollo-boost';

const manyQuery = gql`
  query protocols($inputFilter: CertificationsAthleteFilterInputType) {
    protocols(inputFilter: $inputFilter) {
      rank
      certificationsId
      statusProtocol
      statusStatementAthlete
      countAthletes
      protocolId
    }
  }
`;

export const deleteMutation = gql`
  mutation deleteProtocol($rank: String!, $certificationId: Int!) {
    deleteProtocol(rank: $rank, certificationId: $certificationId) {
      ok
      errors {
        field
        messages
      }
    }
  }
`;

const PROTOCOLS = {
  manyQuery,
  deleteMutation,
};

export default PROTOCOLS;
